
let baseUrl = process.env.NODE_ENV === "development" ? '../../' : '/static/'
let baseUrl1 = process.env.NODE_ENV === "development" ? '../../../' : '/static/'
let urls = {
  baseUrl,
  baseUrl1
}
export default urls